import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock } from "lucide-react";
import { GUIDES } from "../data/guides";
import Seo, { breadcrumbSchema } from "../components/Seo";

export default function Education() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-16">
      <Seo
        title="Jewelry Education & Buying Guides"
        description="Expert guides from Regal Jewels, Chicago: gold purity, the 4Cs of diamonds, ring and bangle sizing, 22K gold buying tips and jewelry care."
        path="/education"
        jsonLd={breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Education", path: "/education" },
        ])}
      />
      <div className="text-center mb-16">
        <p className="section-eyebrow">Learn Before You Buy</p>
        <h1 className="section-title">Jewelry Education</h1>
        <p className="text-[#5c5240] mt-5 max-w-xl mx-auto leading-relaxed">
          Honest, practical guides from our jewelers — so you can buy gold and diamonds with complete confidence.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {GUIDES.map((g) => (
          <Link key={g.slug} to={`/education/${g.slug}`} className="group bg-white border border-[#eee6d6] hover:border-[#cdb87a] hover:shadow-lg p-8 flex flex-col transition-shadow duration-300">
            <BookOpen size={22} strokeWidth={1.3} className="text-[#a8842c]" />
            <h2 className="font-heading text-2xl text-[#1a1713] mt-5 leading-snug group-hover:text-[#a8842c] transition-colors duration-300">{g.title}</h2>
            <p className="text-sm text-[#5c5240] leading-relaxed mt-3 flex-1">{g.summary}</p>
            <div className="flex items-center justify-between mt-6 pt-4 border-t border-[#f2ecdd]">
              <span className="flex items-center gap-1.5 text-xs text-[#8f8571]"><Clock size={13} /> {g.minutes} min read</span>
              <span className="editorial-link">Read <ArrowRight size={11} /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
